function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// [VexFlow](http://vexflow.com) - Copyright (c) Mohit Muthanna 2010.
// Author: Mike Corrigan <corrigan@gmail.com>
//
// This class implements tremolo notation.
import { Vex } from './vex';
import { Modifier } from './modifier';
import { Glyph } from './glyph';
import { GraceNote } from './gracenote';
import { Stem } from './stem';
export var Tremolo = /*#__PURE__*/function (_Modifier) {
  _inherits(Tremolo, _Modifier);

  var _super = _createSuper(Tremolo);

  _createClass(Tremolo, null, [{
    key: "CATEGORY",
    get: function get() {
      return 'tremolo';
    }
  }]);

  function Tremolo(num) {
    var _this;

    _classCallCheck(this, Tremolo);

    _this = _super.call(this);

    _this.setAttribute('type', 'Tremolo');

    _this.num = num;
    _this.note = null;
    _this.index = null;
    _this.position = Modifier.Position.CENTER;
    _this.code = 'tremolo1';
    return _this;
  }

  _createClass(Tremolo, [{
    key: "getCategory",
    value: function getCategory() {
      return Tremolo.CATEGORY;
    }
  }, {
    key: "draw",
    value: function draw() {
      this.checkContext();

      if (!(this.note && this.index != null)) {
        throw new Vex.RERR('NoAttachedNote', "Can't draw Tremolo without a note and index.");
      }

      this.setRendered();
      var stemDirection = this.note.getStemDirection();
      var start = this.note.getModifierStartXY(this.position, this.index);
      var x = start.x;
      var isGraceNote = this.note.getCategory() === 'gracenotes';
      var scale = isGraceNote ? GraceNote.SCALE : 1;
      var category = "tremolo.".concat(isGraceNote ? 'grace' : 'default');
      this.y_spacing = this.musicFont.lookupMetric("".concat(category, ".spacing")) * stemDirection;
      var height = this.num * this.y_spacing;
      var y = this.note.stem.getExtents().baseY - height;

      if (stemDirection < 0) {
        y += this.musicFont.lookupMetric("".concat(category, ".offsetYStemDown")) * scale;
      } else {
        y += this.musicFont.lookupMetric("".concat(category, ".offsetYStemUp")) * scale;
      }

      this.font = {
        family: 'Arial',
        size: 16 * scale,
        weight: ''
      };
      this.render_options = {
        font_scale: this.musicFont.lookupMetric("".concat(category, ".point")),
        stroke_px: 3,
        stroke_spacing: 10 * scale
      };
      x += this.musicFont.lookupMetric("".concat(category, ".offsetXStem").concat(stemDirection === Stem.UP ? 'Up' : 'Down'));

      for (var i = 0; i < this.num; ++i) {
        Glyph.renderGlyph(this.context, x, y, this.render_options.font_scale, this.code, {
          category: category
        });
        y += this.y_spacing;
      }
    }
  }]);

  return Tremolo;
}(Modifier);